import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  password: Yup.string().required('Campo obrigatório'),
  newPassword: Yup.string().required('Campo obrigatório'),
  repeatNewPassword: Yup.string()
    .required('Campo obrigatório')
    .label('Confirme a senha')
    .test('password-match', 'As senhas devem ser iguais', function (value) {
      return this.parent.newPassword === value;
    }),
});
